import React from "react";
import "./GPTeam.css";

const committeeMembers = [
  { name: "श्री रितेश सीताराम परवकर", designation: "गट ग्रामपंचायत खापरी-उबगी", phone: "+91-9881555076", imageUrl: "/images/ritesh.jpg" },
  { name: "श्री सुशील देवमन धोटे", designation: "गट ग्रामपंचायत खापरी-उबगी", phone: "+91-7875132722 ", imageUrl: "/images/sushil.jpg" },
  { name: "श्री हरिचंद पुंडलिक इखनकर", designation: "गट ग्रामपंचायत खापरी-उबगी", phone: "+91 -9284085292", imageUrl: "/images/harichand.jpg" },
  { name: "सौ मालती गजानन झाडे", designation: "गट ग्रामपंचायत खापरी-उबगी", phone: "+91-9921615579 ", imageUrl: "/images/female.png" },
  { name: "सौ बेबी बाल्डेव सरोदे", designation: "गट ग्रामपंचायत खापरी-उबगी", phone: "+91-9049481078 ", imageUrl: "/images/baby.jpg" },
  { name: "सौ संगीता परमेश्वर धुर्वे", designation: "गट ग्रामपंचायत खापरी-उबगी", phone: "+91-8459061439", imageUrl: "/images/sangita.jpg" },
  { name: "सौ मोनिका प्रशांत आवारी", designation: "गट ग्रामपंचायत खापरी-उबगी", phone: "+91-9730334121 ", imageUrl: "/images/monika.jpg" },
    { name: "सौ कीर्ती आशिष आत्राम", designation: "गट ग्रामपंचायत खापरी-उबगी", phone: "+91-7722061973 ", imageUrl: "/images/kirti.jpg" },

  
];

// 🆕 कर्मचारी सेक्शन
const employeeMembers = [
  { name: "श्री अजित ज्ञानेश्वर अडले ", designation: " ग्रामपंचायत कर्मचारी ", phone: "+91", imageUrl: "/images/ajit.jpg" },
  { name: "श्री सुजित सुरेश आवारी", designation: "पाणी पू. कर्माचारी", phone: "+91", imageUrl: "/images/sujit.jpg" },
  { name: " श्री चंद्रशेखर शेषराव तागडे", designation: "ग्रामपंचायत रोजगार सेवक", phone: "+91", imageUrl: "/images/chandrasekhar.jpg" },
  { name: " सौ मनिषा किशोर मोजणकर", designation: "संगणक ऑपरेटर", phone: "+91", imageUrl: "/images/manisha.jpg" },
  { name: "कर्मचारी ", designation: "कार्यालय मदतनीस", phone: "+91", imageUrl: "/images/mens.png" },
  { name: "कर्मचारी ", designation: "कार्यालय सहायक", phone: "+91", imageUrl: "/images/mens.png" },
];

const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img src="/images/sj1.jpg" alt="Emblem" className="gp-logo" />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">The Governing Body — Committed to Community Service</p>
      </div>

      {/* COMMITTEE SECTION */}
      <div className="gp-grid">
        {committeeMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img src={member.imageUrl} alt={member.name} className="gp-photo" />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone">📞 {member.phone}</p>
          </div>
        ))}
      </div>

      {/* 🆕 EMPLOYEE HEADING */}
      <h1 className="gp-title" style={{ marginTop: "60px" }}>ग्रामपंचायत कर्मचारी</h1>

      {/* EMPLOYEE SECTION */}
      <div className="gp-grid">
        {employeeMembers.map((emp, index) => (
          <div key={index} className="gp-card">
            <img src={emp.imageUrl} alt={emp.name} className="gp-photo" />
            <h2 className="gp-name">{emp.name}</h2>
            <p className="gp-designation">{emp.designation}</p>
            <p className="gp-phone">📞 {emp.phone}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2025 Gram Panchayat — All Rights Reserved.
      </div>
    </div>
  );
};

export default GPTeam;
